<ns-grid
  [name]="gridName"
  [gridTitle]="title"
  [data]="data"
  [gridOptions]="options"
  [columns]="columns"
  [loading]="loading"
  [config]="config"
  [resizeType]="resizeType"
></ns-grid>
